import { gql } from '@apollo/client';
import type { Report2VisibilityBenchmarkSectionFragment } from '../../../../../generated/types';
import { dummySectionVisibilityBenchmarkingId } from '../../../constants';
import { useReportDynamicData } from '../../../hooks';
import {
  LockedBenchmarking,
  SectionDescription,
  SectionGroup,
  SectionHeader,
  SectionHeaderGrid,
  SectionInsights,
} from '../../common';
import VisibilityBenchmarkShareOfVoice from './VisibilityBenchmarkShareOfVoice';
import VisibilityBenchmarkShareOfVoiceOverTime from './VisibilityBenchmarkShareOfVoiceOverTime';

export const REPORT2_VISIBILITY_BENCHMARK_SECTION_FRAGMENT = gql`
  fragment Report2VisibilityBenchmarkSection on ReportVisibilityBenchmarkSection {
    id
    title
    state
    subSections {
      ...Report2VisibilityBenchmarkShareOfVoice
      ...Report2VisibilityBenchmarkShareOfVoiceOverTime
      ...Report2SectionInsights
    }
  }
`;

interface Props {
  section: Report2VisibilityBenchmarkSectionFragment;
}
export const VisibilityBenchmarkSection = ({ section }: Props) => {
  const isDummyUpsell = section.id === dummySectionVisibilityBenchmarkingId;
  return isDummyUpsell ? (
    <LockedBenchmarking>
      <Inner section={section} />
    </LockedBenchmarking>
  ) : (
    <Inner section={section} />
  );
};

const Inner = ({ section }: Props) => {
  const { brandColor } = useReportDynamicData();
  return (
    <SectionGroup id={section.id}>
      <SectionHeaderGrid>
        <SectionHeader
          as="h2"
          variant="reportDisplayLarge"
          mobileVariant="reportDisplaySmall"
          section={section}
          color={brandColor}
        />
        <SectionDescription
          as="p"
          variant="reportLabelMedium"
          textAlign="right"
          section={section}
        />
      </SectionHeaderGrid>

      {section.subSections.map(subSection => {
        switch (subSection.__typename) {
          case 'ReportVisibilityBenchmarkShareOfVoice':
            return <VisibilityBenchmarkShareOfVoice key={subSection.id} section={subSection} />;
          case 'ReportVisibilityBenchmarkShareOfVoiceOverTime':
            return (
              <VisibilityBenchmarkShareOfVoiceOverTime key={subSection.id} section={subSection} />
            );
          case 'ReportSectionInsights':
            return <SectionInsights key={subSection.id} section={subSection} />;
          default:
            return null;
        }
      })}
    </SectionGroup>
  );
};
